import React__default from 'react';
import Colors from '../Themes/Colors/colors.js';
import Typography from '../Atoms/Typography.js';
import classNames from './../external_lib/classnames/index.js';
import ItemSummaryCardShimmer from '../Components/Molecules/ItemSummaryCard/Web/index.shimmer.js';

function ItemSummaryCard(_a) {
    var item_title = _a.item_title, quantity = _a.quantity, _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.classes, classes = _c === void 0 ? '' : _c, loading = _a.loading;
    if (loading)
        return React__default.createElement(ItemSummaryCardShimmer, null);
    var showOptions = options.length;
    return (React__default.createElement("div", { className: classNames('item-summary-card', classes) },
        React__default.createElement("div", { className: "item-summary-card__item" },
            React__default.createElement("div", { className: "item-summary-card__name" },
                React__default.createElement(Typography, { variant: "bodyTextOne", color: Colors.BLACK }, item_title)),
            showOptions ? (React__default.createElement("div", { className: "item-summary-card__options" },
                React__default.createElement(Typography, { variant: "bodyTextTwo", color: Colors.SPUN_PEARL }, options.join(', ')))) : null),
        React__default.createElement("div", { className: "item-summary-card__quantity" },
            React__default.createElement(Typography, { variant: "bodyTextOne", noWrap: true },
                "x",
                quantity))));
}

export { ItemSummaryCard as default };
//# sourceMappingURL=ItemSummaryCard.js.map
